import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { CostInfo, MonthlyCostCalcParams } from '../state';

@Injectable({
  providedIn: 'root',
})
export class MonthlyCalculatorService {
  readonly apiUrl = `${environment.legacyApi.host}/portal_api/quick_cost`;
  readonly headers = { 'Content-Type': 'application/json' };

  constructor(private http: HttpClient) {}

  calculateMonthlyCost(payload: MonthlyCostCalcParams): Observable<CostInfo> {
    return this.http.post<CostInfo>(
      `${this.apiUrl}/calculate_prequal`,
      payload,
      {
        headers: this.headers,
      }
    );
  }
}
